<template>
  <div class="modal fade" id="ProductModal" tabindex="-1" style="z-index:2041;" aria-labelledby="ProductModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="Title">
          <span class="Name" :class="{ noProduct: hasProduct == 0 }">{{productName}}</span>
          <span class="noProduct" v-if="hasProduct == 0">（售完）</span>
        </div>
        <div class="Price" v-show="productPrice">NT${{productPrice}}</div>
        <img class="Image" v-show="productImage" :src="Global.Domain + productImage" loading="lazy">
        <div class="Content" v-show="productContent" v-html="productContent"></div>
        <div class="modal-footer" data-bs-dismiss="modal">
          <button class="btn btn-dark" data-mdb-dismiss="modal">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'
export default {
  name: "ProductModal",
  props: {
    productName: String,      // 產品名稱
    productPrice: Number,     // 產品價格
    productImage: String,     // 產品圖片
    productContent: String,   // 產品內容
    hasProduct: String,       // 是否有貨
  },
  data() {
    return {
      Global: Global
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  text-align: center;
  .modal-dialog {
    .modal-content {
      padding-top: 20px;
      > .Title {
        margin-bottom: 15px;
        font-size: 20px;
        font-weight: bold;
        .noProduct {
          color: red;
        }
      }
      > .Price {
        margin-bottom: 15px;
        font-size: 20px;
        font-weight: bold;
        color: #FFBB00;
      }
      > .Image {
        border-radius: 8px;
        max-height: 300px;
        max-width: 300px;
        width: auto;
        height: auto;
        margin: auto;
        margin-bottom: 30px;
      }
      > .Content {
        padding-left: 30px;
        margin-bottom: 15px;
        text-align: left;
      }
      > .modal-footer {
        > button {
          font-weight: bold;
        }
      }
    }
  }
}
</style>